import { AxiosInstance } from 'axios'
import { IJsonApiSerializer } from '../JsonApiSerializer'

class TroubleReportService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public async getTroubleReports(params, page) {
    const { data } = await this.httpClient.get(`/agent/api/trouble_reports?page=${page}`, {
      params,
    })
    const troubles = this.serializer.parseResourceData(
      data.troubles.troubles,
      data.troubles.troubles.data
    )
    const pagination = data.troubles.troubles.meta

    return { troubles, pagination }
  }

  public async getTroubleReport(id) {
    const { data } = await this.httpClient.get(`/agent/api/trouble_reports/${id}`)
    const trouble = this.serializer.parseResourceData(data.trouble, data.trouble.data)

    return { trouble }
  }

  public async updateTrouble(trouble, params) {
    const { data } = await this.httpClient.put(`/agent/api/trouble_reports/${trouble.id}`, {
      trouble: params,
    })
    const { flush } = data
    const updatedTrouble = this.serializer.parseResourceData(data.trouble, data.trouble.data)

    return { trouble: updatedTrouble, flush }
  }
}

export default TroubleReportService
